import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { IOtaPerformanceResponse } from '../interfaces/ota-performance.interface';

@Injectable({
    providedIn: 'root'
})
export class OtaPerformanceService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getOtaPerformance(beginDate: string, endDate: string): Observable<IOtaPerformanceResponse> {
        const apiUrl = `${this.baseUrl}/dashboard/otaPerformance`;

        let params = new HttpParams().set('beginDate', beginDate).set('endDate', endDate);

        return this.http.get<IOtaPerformanceResponse>(apiUrl, { params });
    }
}
